import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { DocumentService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class DocumentDeleteDocumentResolve implements Resolve<any> {

  constructor(private documentService: DocumentService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.documentService.deleteDocument(
      route.data.id || route.params.id || route.queryParams.id
    );
  }
}
